export enum TooltipIds {
    CATALOG_BUTTON_ON_STARTUP,
    PROPERTY_PANEL_AFTER_ARTICLE_ADD,
    CATALOG_FOLDER_ICON,
    FLOORPLAN_ICON,
    DRAW_WALL_ICON,
    CUSTOM,
    ARCHITECTURE_HINT
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/TooltipIds.ts